// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Snasm-W05-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 480px) {

  .container {
    max-width: 480px;
  }
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1440px) {

  .container {
    max-width: 1440px;
  }
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.center-absolute {
  position: absolute;
  top: 50%;
  left: 50%;
  --tw-translate-x: -50%;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.primary-btn {
  border-width: 1px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(255 102 0 / var(--tw-bg-opacity, 1));
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-family: Manrope;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(255 252 250 / var(--tw-text-opacity, 1));
  --tw-shadow: 0px 3px 49px 0px #FF660080;
  --tw-shadow-colored: 0px 3px 49px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.primary-btn:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 252 250 / var(--tw-border-opacity, 1));
  background-color: transparent;
  --tw-shadow: 0px 3px 49px 0px #FFFFFF80;
  --tw-shadow-colored: 0px 3px 49px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
@media (min-width: 1024px) {

  .primary-btn {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.disable-focus:focus-within {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.disable-focus:focus {
  border-style: none;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.disable-focus:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.text-secondary {
  font-family: Manrope;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
  color: #FFFFFFCC;
}
@media (min-width: 640px) {

  .text-secondary {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 1024px) {

  .text-secondary {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.os-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  width: 80px;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(163 163 163 / var(--tw-bg-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.os-icon:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 102 0 / var(--tw-bg-opacity, 1));
}
.get-app-button {
  max-width: none;
  object-fit: cover;
}
.focus-button:focus-within {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-button:focus {
  border-style: none;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-button:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-button:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(255 102 0 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 102 0 / var(--tw-text-opacity, 1));
}
.focus-button:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 102 0 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 102 0 / var(--tw-text-opacity, 1));
}
.focus-button:focus {
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(255 102 0 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 102 0 / var(--tw-text-opacity, 1));
}
.auth-button {
  border-width: 1px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(255 102 0 / var(--tw-bg-opacity, 1));
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-family: Manrope;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(255 252 250 / var(--tw-text-opacity, 1));
  --tw-shadow: 0px 3px 49px 0px #FF660080;
  --tw-shadow-colored: 0px 3px 49px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.auth-button:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 252 250 / var(--tw-border-opacity, 1));
  background-color: transparent;
  --tw-shadow: 0px 3px 49px 0px #FFFFFF80;
  --tw-shadow-colored: 0px 3px 49px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
@media (min-width: 1024px) {

  .auth-button {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.auth-button {
  min-width: 108px;
  border-radius: 0.25rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-weight: 400;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.auth-button:hover {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.\\!input {
  width: 100%;
  border-radius: 0.25rem;
  border-width: 1px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(29 29 29 / var(--tw-bg-opacity, 1));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  --tw-text-opacity: 1;
  color: rgb(255 252 250 / var(--tw-text-opacity, 1));
}
.\\!input:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 102 0 / var(--tw-border-opacity, 1));
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.input {
  width: 100%;
  border-radius: 0.25rem;
  border-width: 1px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(29 29 29 / var(--tw-bg-opacity, 1));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  --tw-text-opacity: 1;
  color: rgb(255 252 250 / var(--tw-text-opacity, 1));
}
.input:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 102 0 / var(--tw-border-opacity, 1));
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.text-focus:focus-within {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.text-focus:focus {
  border-style: none;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.text-focus:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.text-focus {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.text-focus:focus-within {
  --tw-text-opacity: 1;
  color: rgb(255 102 0 / var(--tw-text-opacity, 1));
}
.text-focus:hover {
  --tw-text-opacity: 1;
  color: rgb(255 102 0 / var(--tw-text-opacity, 1));
}
.select {
  max-height: 350px;
  width: 100%;
  border-radius: 1rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity, 1));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.select:focus {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.select-option {
  max-width: 100%;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.25rem;
}
.visible {
  visibility: visible;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.-top-2 {
  top: -0.5rem;
}
.-top-5 {
  top: -1.25rem;
}
.-top-\\[47px\\] {
  top: -47px;
}
.bottom-0 {
  bottom: 0px;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-\\[1\\.875rem\\] {
  left: 1.875rem;
}
.left-auto {
  left: auto;
}
.right-0 {
  right: 0px;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-7 {
  right: 1.75rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-10 {
  top: 2.5rem;
}
.top-4 {
  top: 1rem;
}
.top-\\[72px\\] {
  top: 72px;
}
.-z-10 {
  z-index: -10;
}
.z-10 {
  z-index: 10;
}
.z-\\[999\\] {
  z-index: 999;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.-ml-4 {
  margin-left: -1rem;
}
.mb-14 {
  margin-bottom: 3.5rem;
}
.ml-auto {
  margin-left: auto;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[0\\.875rem\\] {
  margin-top: 0.875rem;
}
.mt-\\[3\\.5rem\\] {
  margin-top: 3.5rem;
}
.mt-auto {
  margin-top: auto;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.inline-grid {
  display: inline-grid;
}
.contents {
  display: contents;
}
.list-item {
  display: list-item;
}
.hidden {
  display: none;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-2 {
  height: 0.5rem;
}
.h-\\[142\\.5px\\] {
  height: 142.5px;
}
.h-\\[186px\\] {
  height: 186px;
}
.h-\\[28px\\] {
  height: 28px;
}
.h-\\[318px\\] {
  height: 318px;
}
.h-\\[32px\\] {
  height: 32px;
}
.h-\\[34px\\] {
  height: 34px;
}
.h-\\[43\\.75vw\\] {
  height: 43.75vw;
}
.h-\\[45px\\] {
  height: 45px;
}
.h-fit {
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-min {
  height: min-content;
}
.max-h-\\[500px\\] {
  max-height: 500px;
}
.max-h-\\[85vh\\] {
  max-height: 85vh;
}
.max-h-max {
  max-height: max-content;
}
.min-h-\\[20vh\\] {
  min-height: 20vh;
}
.min-h-screen {
  min-height: 100vh;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-4 {
  width: 1rem;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[170px\\] {
  width: 170px;
}
.w-\\[220px\\] {
  width: 220px;
}
.w-\\[28px\\] {
  width: 28px;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[34px\\] {
  width: 34px;
}
.w-\\[62\\.5vw\\] {
  width: 62.5vw;
}
.w-\\[96px\\] {
  width: 96px;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-min {
  width: min-content;
}
.min-w-16 {
  min-width: 4rem;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[400px\\] {
  min-width: 400px;
}
.min-w-max {
  min-width: max-content;
}
.max-w-\\[237px\\] {
  max-width: 237px;
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[320px\\] {
  max-width: 320px;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-max {
  max-width: max-content;
}
.max-w-xs {
  max-width: 20rem;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[70\\%\\] {
  --tw-translate-y: -70%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1\\/2 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-10 {
  --tw-translate-y: 2.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-0 {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-\\[20px\\2c 1fr\\] {
  grid-template-columns: 20px 1fr;
}
.grid-cols-\\[30px\\2c 1fr\\] {
  grid-template-columns: 30px 1fr;
}
.grid-cols-\\[65px\\2c 1fr\\] {
  grid-template-columns: 65px 1fr;
}
.grid-cols-\\[auto\\2c 1fr\\] {
  grid-template-columns: auto 1fr;
}
.grid-cols-\\[minmax\\(0\\2c 190px\\)\\] {
  grid-template-columns: minmax(0,190px);
}
.grid-cols-\\[repeat\\(2\\2c auto\\)\\] {
  grid-template-columns: repeat(2,auto);
}
.grid-rows-\\[1fr\\2c auto\\] {
  grid-template-rows: 1fr auto;
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-items-center {
  place-items: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-11 {
  gap: 2.75rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-14 {
  gap: 3.5rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-9 {
  gap: 2.25rem;
}
.gap-\\[0\\.375rem\\] {
  gap: 0.375rem;
}
.gap-\\[0\\.75rem\\] {
  gap: 0.75rem;
}
.gap-\\[0\\.875rem\\] {
  gap: 0.875rem;
}
.gap-\\[4\\.75rem\\] {
  gap: 4.75rem;
}
.justify-self-center {
  justify-self: center;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[0\\.25rem\\] {
  border-radius: 0.25rem;
}
.rounded-\\[100px\\] {
  border-radius: 100px;
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-\\[6px\\] {
  border-radius: 6px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.border {
  border-width: 1px;
}
.border-\\[0\\.25rem\\] {
  border-width: 0.25rem;
}
.border-\\[0\\.7px\\] {
  border-width: 0.7px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-\\[\\#EFEFEF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(239 239 239 / var(--tw-border-opacity, 1));
}
.border-grey-primary {
  --tw-border-opacity: 1;
  border-color: rgb(226 226 226 / var(--tw-border-opacity, 1));
}
.border-primary-orange {
  --tw-border-opacity: 1;
  border-color: rgb(255 102 0 / var(--tw-border-opacity, 1));
}
.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 252 250 / var(--tw-border-opacity, 1));
}
.border-white-30 {
  border-color: #FFFFFF1E;
}
.border-white-primary {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-b-white\\/20 {
  border-bottom-color: rgb(255 252 250 / 0.2);
}
.bg-\\[\\#000000\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#151515\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(21 21 21 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF9700\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 151 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFEEE32B\\] {
  background-color: #FFEEE32B;
}
.bg-black-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black-primary\\/\\[77\\] {
  background-color: rgb(0 0 0 / 77);
}
.bg-black-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(23 23 23 / var(--tw-bg-opacity, 1));
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 252 250 / var(--tw-bg-opacity, 1));
}
.bg-white-10 {
  background-color: #FFFFFF1A;
}
.bg-opacity-70 {
  --tw-bg-opacity: 0.7;
}
.bg-\\[length\\:160px_160px\\2c contain\\] {
  background-size: 160px 160px,contain;
}
.bg-\\[length\\:314px_340px\\2c cover\\] {
  background-size: 314px 340px,cover;
}
.bg-cover {
  background-size: cover;
}
.\\!bg-\\[0\\%_50\\%\\] {
  background-position: 0% 50% !important;
}
.\\!bg-\\[100\\%_50\\%\\] {
  background-position: 100% 50% !important;
}
.bg-\\[position\\:top_120px_right_70px\\2c _right_0px_center\\] {
  background-position: top 120px right 70px, right 0px center;
}
.bg-\\[position\\:top_219px_right_72px\\2c _center\\] {
  background-position: top 219px right 72px, center;
}
.bg-center {
  background-position: center;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.p-0 {
  padding: 0px;
}
.p-2 {
  padding: 0.5rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-7 {
  padding: 1.75rem;
}
.p-8 {
  padding: 2rem;
}
.\\!px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-9 {
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.px-\\[0\\.875rem\\] {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-\\[6\\.75rem\\] {
  padding-left: 6.75rem;
  padding-right: 6.75rem;
}
.px-\\[9\\.375rem\\] {
  padding-left: 9.375rem;
  padding-right: 9.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-11 {
  padding-bottom: 2.75rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-16 {
  padding-bottom: 4rem;
}
.pb-28 {
  padding-bottom: 7rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-7 {
  padding-bottom: 1.75rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-\\[23\\.5rem\\] {
  padding-bottom: 23.5rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-16 {
  padding-top: 4rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-40 {
  padding-top: 10rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-60 {
  padding-top: 15rem;
}
.pt-9 {
  padding-top: 2.25rem;
}
.pt-\\[4\\.5rem\\] {
  padding-top: 4.5rem;
}
.pt-\\[6\\.25rem\\] {
  padding-top: 6.25rem;
}
.pt-\\[96px\\] {
  padding-top: 96px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.align-middle {
  vertical-align: middle;
}
.font-manrope {
  font-family: Manrope;
}
.font-raleway {
  font-family: Raleway;
}
.font-snasm {
  font-family: snasm;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-\\[1\\.25rem\\] {
  font-size: 1.25rem;
}
.text-\\[1\\.5rem\\] {
  font-size: 1.5rem;
}
.text-\\[2rem\\] {
  font-size: 2rem;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.lining-nums {
  --tw-numeric-figure: lining-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-10 {
  line-height: 2.5rem;
}
.leading-4 {
  line-height: 1rem;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-8 {
  line-height: 2rem;
}
.leading-\\[1\\.125rem\\] {
  line-height: 1.125rem;
}
.leading-\\[2\\.25rem\\] {
  line-height: 2.25rem;
}
.text-\\[\\#9CA3AF\\] {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-\\[\\#EFEFEF\\] {
  --tw-text-opacity: 1;
  color: rgb(239 239 239 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFFCFA\\] {
  --tw-text-opacity: 1;
  color: rgb(255 252 250 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFFCFA\\]\\/70 {
  color: rgb(255 252 250 / 0.7);
}
.text-black-primary {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-grey-primary {
  --tw-text-opacity: 1;
  color: rgb(226 226 226 / var(--tw-text-opacity, 1));
}
.text-primary-orange {
  --tw-text-opacity: 1;
  color: rgb(255 102 0 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 252 250 / var(--tw-text-opacity, 1));
}
.text-white-70 {
  color: #FFFFFFB3;
}
.text-white-80 {
  color: #FFFFFFCC;
}
.text-white-primary {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.decoration-white-70 {
  text-decoration-color: #FFFFFFB3;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-60 {
  opacity: 0.6;
}
.shadow-\\[0_2px_15px_-3px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.07\\)\\2c 0_10px_20px_-2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\] {
  --tw-shadow: 0 2px 15px -3px rgba(0,0,0,0.07),0 10px 20px -2px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0 2px 15px -3px var(--tw-shadow-color), 0 10px 20px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert {
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-\\[6px\\] {
  --tw-backdrop-blur: blur(6px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.clip-bottom {
		clip-path: polygon(0 0, 100% 0, 100% 100%, 0 calc(100% - 6vw));
	}
.\\[filter\\:blur\\(100px\\)\\] {
  filter: blur(100px);
}
.\\[filter\\:blur\\(200px\\)\\] {
  filter: blur(200px);
}

html {
	scroll-behavior: smooth;
}

::-webkit-scrollbar-track {
	background-color: rgba(0, 0, 0, 0);
}

::-webkit-scrollbar-thumb {
	background-color: #444444;
	border-radius: 4px;
}

::-webkit-scrollbar {
	background-color: rgba(68, 68, 68, 0.9);
}

::-webkit-scrollbar-thumb:horizontal {
	background-color: #444444;
}

.react-pricing-table {
	width: 100%;
}

.price {
	transition: transform 0.5s ease-out !important;
}

.price:hover {
	margin-top: 20px !important;
	transform: translateY(-20px);
}

#basic-header {
	background-color: #ff6600;
	color: #ffffff;
}

.mask {
	color: #454e5c;
	opacity: 0.8;
}

.header {
	background: linear-gradient(
		-45deg,
		transparent,
		transparent,
		#272727,
		#272727
	);
	background-size: 400% 400%;
}

.header-rtl-animation {
	animation: header-animation 2s ease;
}

.header-ltr-animation {
	animation: header-animation 2s ease reverse;
}

@keyframes header-animation {
	0% {
		background-position: 100% 50%;
	}
	50% {
		background-position: 50% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}

@keyframes pulsate {
	0% {
		transform: scale(1);
		opacity: 1;
	}
	50% {
		transform: scale(1.4);
		opacity: 0.7;
	}
	100% {
		transform: scale(1);
		opacity: 1;
	}
}

@keyframes fadeInOut {
	0%,
	100% {
		opacity: 0;
	}
	10%,
	90% {
		opacity: 1;
	}
}

* {
	font-variant-numeric: lining-nums;
}

@font-face {
	font-family: "snasm";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@media (min-width: 640px) {
	.sm\\:flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.placeholder\\:capitalize::placeholder {
  text-transform: capitalize;
}

.placeholder\\:italic::placeholder {
  font-style: italic;
}

.placeholder\\:text-white-70::placeholder {
  color: #FFFFFFB3;
}

.focus-within\\:text-primary-orange:focus-within {
  --tw-text-opacity: 1;
  color: rgb(255 102 0 / var(--tw-text-opacity, 1));
}

.focus-within\\:text-white:focus-within {
  --tw-text-opacity: 1;
  color: rgb(255 252 250 / var(--tw-text-opacity, 1));
}

.hover\\:border-primary-orange:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 102 0 / var(--tw-border-opacity, 1));
}

.hover\\:border-slate-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}

.hover\\:border-transparent:hover {
  border-color: transparent;
}

.hover\\:bg-primary-orange:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 102 0 / var(--tw-bg-opacity, 1));
}

.hover\\:text-\\[\\#EFEFEF\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(239 239 239 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary-orange:hover {
  --tw-text-opacity: 1;
  color: rgb(255 102 0 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-900:hover {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:shadow:hover {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:text-white:focus {
  --tw-text-opacity: 1;
  color: rgb(255 252 250 / var(--tw-text-opacity, 1));
}

.focus-visible\\:border:focus-visible {
  border-width: 1px;
}

.focus-visible\\:border-transparent:focus-visible {
  border-color: transparent;
}

.focus-visible\\:bg-transparent:focus-visible {
  background-color: transparent;
}

.focus-visible\\:text-primary-orange:focus-visible {
  --tw-text-opacity: 1;
  color: rgb(255 102 0 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:text-primary-orange {
  --tw-text-opacity: 1;
  color: rgb(255 102 0 / var(--tw-text-opacity, 1));
}

@media (min-width: 480px) {

  .xs\\:flex-row {
    flex-direction: row;
  }

  .xs\\:gap-16 {
    gap: 4rem;
  }

  .xs\\:px-9 {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
}

@media (min-width: 640px) {

  .sm\\:right-4 {
    right: 1rem;
  }

  .sm\\:mb-32 {
    margin-bottom: 8rem;
  }

  .sm\\:mt-\\[3\\.5rem\\] {
    margin-top: 3.5rem;
  }

  .sm\\:h-\\[270px\\] {
    height: 270px;
  }

  .sm\\:w-\\[320px\\] {
    width: 320px;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:min-w-\\[120px\\] {
    min-width: 120px;
  }

  .sm\\:min-w-\\[416px\\] {
    min-width: 416px;
  }

  .sm\\:max-w-\\[350px\\] {
    max-width: 350px;
  }

  .sm\\:max-w-\\[400px\\] {
    max-width: 400px;
  }

  .sm\\:grid-cols-\\[28px\\2c 1fr\\] {
    grid-template-columns: 28px 1fr;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:items-end {
    align-items: flex-end;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-0 {
    gap: 0px;
  }

  .sm\\:gap-10 {
    gap: 2.5rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:gap-7 {
    gap: 1.75rem;
  }

  .sm\\:gap-8 {
    gap: 2rem;
  }

  .sm\\:gap-\\[4\\.5rem\\] {
    gap: 4.5rem;
  }

  .sm\\:p-0 {
    padding: 0px;
  }

  .sm\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .sm\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:px-\\[6\\.75rem\\] {
    padding-left: 6.75rem;
    padding-right: 6.75rem;
  }

  .sm\\:px-\\[9\\.375rem\\] {
    padding-left: 9.375rem;
    padding-right: 9.375rem;
  }

  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:pb-24 {
    padding-bottom: 6rem;
  }

  .sm\\:pb-28 {
    padding-bottom: 7rem;
  }

  .sm\\:pl-3 {
    padding-left: 0.75rem;
  }

  .sm\\:pl-\\[0\\.625rem\\] {
    padding-left: 0.625rem;
  }

  .sm\\:pr-6 {
    padding-right: 1.5rem;
  }

  .sm\\:pt-16 {
    padding-top: 4rem;
  }

  .sm\\:pt-72 {
    padding-top: 18rem;
  }

  .sm\\:pt-\\[11\\.5rem\\] {
    padding-top: 11.5rem;
  }

  .sm\\:pt-\\[4\\.5rem\\] {
    padding-top: 4.5rem;
  }

  .sm\\:pt-\\[96px\\] {
    padding-top: 96px;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-\\[2\\.125rem\\] {
    font-size: 2.125rem;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .sm\\:leading-6 {
    line-height: 1.5rem;
  }

  .sm\\:leading-\\[1\\.125rem\\] {
    line-height: 1.125rem;
  }

  .sm\\:leading-\\[3\\.125rem\\] {
    line-height: 3.125rem;
  }
}

@media (min-width: 768px) {

  .md\\:absolute {
    position: absolute;
  }

  .md\\:left-0 {
    left: 0px;
  }

  .md\\:left-auto {
    left: auto;
  }

  .md\\:right-0 {
    right: 0px;
  }

  .md\\:top-\\[10\\%\\] {
    top: 10%;
  }

  .md\\:mt-5 {
    margin-top: 1.25rem;
  }

  .md\\:block {
    display: block;
  }

  .md\\:h-\\[45vw\\] {
    height: 45vw;
  }

  .md\\:w-\\[45vw\\] {
    width: 45vw;
  }

  .md\\:w-full {
    width: 100%;
  }

  .md\\:-translate-y-1\\/2 {
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\\:translate-x-1\\/2 {
    --tw-translate-x: 50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\\:translate-y-0 {
    --tw-translate-y: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\\:translate-y-40 {
    --tw-translate-y: 10rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .md\\:grid-cols-\\[repeat\\(2\\2c auto\\)\\] {
    grid-template-columns: repeat(2,auto);
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:gap-10 {
    gap: 2.5rem;
  }

  .md\\:gap-12 {
    gap: 3rem;
  }

  .md\\:gap-3 {
    gap: 0.75rem;
  }

  .md\\:gap-8 {
    gap: 2rem;
  }

  .md\\:\\!px-\\[35px\\] {
    padding-left: 35px !important;
    padding-right: 35px !important;
  }

  .md\\:px-14 {
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .md\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:px-\\[6\\.5rem\\] {
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .md\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .md\\:pb-14 {
    padding-bottom: 3.5rem;
  }

  .md\\:pl-\\[46\\.875vw\\] {
    padding-left: 46.875vw;
  }

  .md\\:pr-5 {
    padding-right: 1.25rem;
  }

  .md\\:pt-24 {
    padding-top: 6rem;
  }

  .md\\:pt-40 {
    padding-top: 10rem;
  }

  .md\\:pt-5 {
    padding-top: 1.25rem;
  }

  .md\\:pt-\\[88px\\] {
    padding-top: 88px;
  }

  .md\\:text-\\[1\\.5rem\\] {
    font-size: 1.5rem;
  }
}

@media (min-width: 1024px) {

  .lg\\:right-4 {
    right: 1rem;
  }

  .lg\\:top-1\\/4 {
    top: 25%;
  }

  .lg\\:top-\\[5px\\] {
    top: 5px;
  }

  .lg\\:mt-11 {
    margin-top: 2.75rem;
  }

  .lg\\:mt-8 {
    margin-top: 2rem;
  }

  .lg\\:mt-\\[0\\.875rem\\] {
    margin-top: 0.875rem;
  }

  .lg\\:mt-\\[1\\.375rem\\] {
    margin-top: 1.375rem;
  }

  .lg\\:h-16 {
    height: 4rem;
  }

  .lg\\:h-\\[190px\\] {
    height: 190px;
  }

  .lg\\:h-\\[30vw\\] {
    height: 30vw;
  }

  .lg\\:h-\\[38px\\] {
    height: 38px;
  }

  .lg\\:h-\\[405px\\] {
    height: 405px;
  }

  .lg\\:h-\\[54px\\] {
    height: 54px;
  }

  .lg\\:h-auto {
    height: auto;
  }

  .lg\\:w-16 {
    width: 4rem;
  }

  .lg\\:w-\\[112px\\] {
    width: 112px;
  }

  .lg\\:w-\\[120px\\] {
    width: 120px;
  }

  .lg\\:w-\\[400px\\] {
    width: 400px;
  }

  .lg\\:w-\\[500px\\] {
    width: 500px;
  }

  .lg\\:w-\\[80vw\\] {
    width: 80vw;
  }

  .lg\\:min-w-24 {
    min-width: 6rem;
  }

  .lg\\:max-w-\\[450px\\] {
    max-width: 450px;
  }

  .lg\\:max-w-\\[540px\\] {
    max-width: 540px;
  }

  .lg\\:translate-y-1\\/4 {
    --tw-translate-y: 25%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[32px\\2c 1fr\\] {
    grid-template-columns: 32px 1fr;
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 228px\\)\\] {
    grid-template-columns: minmax(0,228px);
  }

  .lg\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .lg\\:gap-10 {
    gap: 2.5rem;
  }

  .lg\\:gap-14 {
    gap: 3.5rem;
  }

  .lg\\:gap-16 {
    gap: 4rem;
  }

  .lg\\:gap-24 {
    gap: 6rem;
  }

  .lg\\:gap-28 {
    gap: 7rem;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:gap-5 {
    gap: 1.25rem;
  }

  .lg\\:gap-6 {
    gap: 1.5rem;
  }

  .lg\\:gap-7 {
    gap: 1.75rem;
  }

  .lg\\:gap-8 {
    gap: 2rem;
  }

  .lg\\:bg-\\[position\\:top_120px_right_370px\\2c _right_0px_center\\] {
    background-position: top 120px right 370px, right 0px center;
  }

  .lg\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .lg\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .lg\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .lg\\:px-28 {
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .lg\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:px-\\[1\\.125rem\\] {
    padding-left: 1.125rem;
    padding-right: 1.125rem;
  }

  .lg\\:px-\\[9\\.375rem\\] {
    padding-left: 9.375rem;
    padding-right: 9.375rem;
  }

  .lg\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .lg\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .lg\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .lg\\:pb-32 {
    padding-bottom: 8rem;
  }

  .lg\\:pb-40 {
    padding-bottom: 10rem;
  }

  .lg\\:pl-5 {
    padding-left: 1.25rem;
  }

  .lg\\:pl-6 {
    padding-left: 1.5rem;
  }

  .lg\\:pr-10 {
    padding-right: 2.5rem;
  }

  .lg\\:pr-8 {
    padding-right: 2rem;
  }

  .lg\\:pt-28 {
    padding-top: 7rem;
  }

  .lg\\:pt-36 {
    padding-top: 9rem;
  }

  .lg\\:pt-8 {
    padding-top: 2rem;
  }

  .lg\\:pt-96 {
    padding-top: 24rem;
  }

  .lg\\:pt-\\[96px\\] {
    padding-top: 96px;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .lg\\:text-\\[1\\.75rem\\] {
    font-size: 1.75rem;
  }

  .lg\\:text-\\[3\\.25rem\\] {
    font-size: 3.25rem;
  }

  .lg\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .lg\\:leading-\\[3\\.875rem\\] {
    line-height: 3.875rem;
  }
}

@media (min-width: 1280px) {

  .xl\\:flex {
    display: flex;
  }

  .xl\\:h-16 {
    height: 4rem;
  }

  .xl\\:h-\\[47px\\] {
    height: 47px;
  }

  .xl\\:h-\\[560px\\] {
    height: 560px;
  }

  .xl\\:h-\\[70px\\] {
    height: 70px;
  }

  .xl\\:min-h-\\[40vw\\] {
    min-height: 40vw;
  }

  .xl\\:min-h-\\[45vw\\] {
    min-height: 45vw;
  }

  .xl\\:w-16 {
    width: 4rem;
  }

  .xl\\:w-\\[140px\\] {
    width: 140px;
  }

  .xl\\:w-\\[157px\\] {
    width: 157px;
  }

  .xl\\:w-\\[65vw\\] {
    width: 65vw;
  }

  .xl\\:w-\\[690px\\] {
    width: 690px;
  }

  .xl\\:w-\\[85\\%\\] {
    width: 85%;
  }

  .xl\\:min-w-\\[320px\\] {
    min-width: 320px;
  }

  .xl\\:max-w-\\[400px\\] {
    max-width: 400px;
  }

  .xl\\:flex-col {
    flex-direction: column;
  }

  .xl\\:justify-center {
    justify-content: center;
  }

  .xl\\:gap-11 {
    gap: 2.75rem;
  }

  .xl\\:gap-12 {
    gap: 3rem;
  }

  .xl\\:gap-\\[9\\.375rem\\] {
    gap: 9.375rem;
  }

  .xl\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .xl\\:px-36 {
    padding-left: 9rem;
    padding-right: 9rem;
  }

  .xl\\:px-\\[9\\.375rem\\] {
    padding-left: 9.375rem;
    padding-right: 9.375rem;
  }

  .xl\\:pb-32 {
    padding-bottom: 8rem;
  }

  .xl\\:pt-44 {
    padding-top: 11rem;
  }

  .xl\\:pt-\\[32rem\\] {
    padding-top: 32rem;
  }

  .xl\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
}

@media (min-width: 1440px) {

  .\\32xl\\:min-w-\\[400px\\] {
    min-width: 400px;
  }

  .\\32xl\\:\\!px-\\[60px\\] {
    padding-left: 60px !important;
    padding-right: 60px !important;
  }

  .\\32xl\\:px-36 {
    padding-left: 9rem;
    padding-right: 9rem;
  }
}

.\\[\\&\\>td\\]\\:py-2>td {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.\\[\\&\\>td\\]\\:py-3>td {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

@media (min-width: 640px) {

  .sm\\:\\[\\&\\>td\\]\\:py-3>td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
}

@media (min-width: 1024px) {

  .lg\\:\\[\\&\\>td\\]\\:py-5>td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/client/App/global.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAuHlB;EAAA,aAAuC;EAAvC,mBAAuC;EAAvC;AAAuC;AAQvC;EAAA,aAAwC;EAAxC,mBAAwC;EAAxC;AAAwC;AAIxC;EAAA,kBAAkE;EAAlE,QAAkE;EAAlE,SAAkE;EAAlE,sBAAkE;EAAlE,sBAAkE;EAAlE;AAAkE;AAIlE;EAAA,iBAAuN;EAAvN,yBAAuN;EAAvN,kBAAuN;EAAvN,0DAAuN;EAAvN,oBAAuN;EAAvN,uBAAuN;EAAvN,oBAAuN;EAAvN,mBAAuN;EAAvN,oBAAuN;EAAvN,gBAAuN;EAAvN,oBAAuN;EAAvN,mDAAuN;EAAvN,uCAAuN;EAAvN,4DAAuN;EAAvN,uGAAuN;EAAvN,wBAAuN;EAAvN,wDAAuN;EAAvN;AAAuN;AAAvN;EAAA,sBAAuN;EAAvN,4DAAuN;EAAvN,6BAAuN;EAAvN,uCAAuN;EAAvN,4DAAuN;EAAvN;AAAuN;AAAvN;;EAAA;IAAA,eAAuN;IAAvN;EAAuN;AAAA;AAIvN;EAAA,8BAAgG;EAAhG;AAAgG;AAAhG;EAAA,kBAAgG;EAAhG,8BAAgG;EAAhG;AAAgG;AAAhG;EAAA,8BAAgG;EAAhG;AAAgG;AAIhG;EAAA,oBAA6E;EAA7E,kBAA6E;EAA7E,iBAA6E;EAA7E,gBAA6E;EAA7E;AAA6E;AAA7E;;EAAA;IAAA,mBAA6E;IAA7E;EAA6E;AAAA;AAA7E;;EAAA;IAAA,eAA6E;IAA7E;EAA6E;AAAA;AAI7E;EAAA,aAAwG;EAAxG,mBAAwG;EAAxG,uBAAwG;EAAxG,YAAwG;EAAxG,WAAwG;EAAxG,qBAAwG;EAAxG,kBAAwG;EAAxG,4DAAwG;EAAxG,+FAAwG;EAAxG,wDAAwG;EAAxG;AAAwG;AAAxG;EAAA,kBAAwG;EAAxG;AAAwG;AAIxG;EAAA,eAA8B;EAA9B;AAA8B;AAI9B;EAAA,8BAAuN;EAAvN;AAAuN;AAAvN;EAAA,kBAAuN;EAAvN,8BAAuN;EAAvN;AAAuN;AAAvN;EAAA,8BAAuN;EAAvN;AAAuN;AAAvN;EAAA,sBAAuN;EAAvN,0DAAuN;EAAvN,oBAAuN;EAAvN;AAAuN;AAAvN;EAAA,sBAAuN;EAAvN,0DAAuN;EAAvN,oBAAuN;EAAvN;AAAuN;AAAvN;EAAA,mBAAuN;EAAvN,sBAAuN;EAAvN,0DAAuN;EAAvN,oBAAuN;EAAvN;AAAuN;AAIvN;EAAA,iBAAgG;EAAhG,yBAAgG;EAAhG,kBAAgG;EAAhG,0DAAgG;EAAhG,oBAAgG;EAAhG,uBAAgG;EAAhG,oBAAgG;EAAhG,mBAAgG;EAAhG,oBAAgG;EAAhG,gBAAgG;EAAhG,oBAAgG;EAAhG,mDAAgG;EAAhG,uCAAgG;EAAhG,4DAAgG;EAAhG,uGAAgG;EAAhG,wBAAgG;EAAhG,wDAAgG;EAAhG;AAAgG;AAAhG;EAAA,sBAAgG;EAAhG,4DAAgG;EAAhG,6BAAgG;EAAhG,uCAAgG;EAAhG,4DAAgG;EAAhG;AAAgG;AAAhG;;EAAA;IAAA,eAAgG;IAAhG;EAAgG;AAAA;AAAhG;EAAA,gBAAgG;EAAhG,sBAAgG;EAAhG,qBAAgG;EAAhG,wBAAgG;EAAhG,gBAAgG;EAAhG,sBAAgG;EAAhG,8BAAgG;EAAhG;AAAgG;AAAhG;EAAA,sBAAgG;EAAhG,8BAAgG;EAAhG;AAAgG;AAIhG;EAAA,WAAgI;EAAhI,sBAAgI;EAAhI,iBAAgI;EAAhI,yBAAgI;EAAhI,kBAAgI;EAAhI,yDAAgI;EAAhI,kBAAgI;EAAhI,mBAAgI;EAAhI,oBAAgI;EAAhI,uBAAgI;EAAhI,oBAAgI;EAAhI;AAAgI;AAAhI;EAAA,sBAAgI;EAAhI,0DAAgI;EAAhI,8BAAgI;EAAhI;AAAgI;AAAhI;EAAA,WAAgI;EAAhI,sBAAgI;EAAhI,iBAAgI;EAAhI,yBAAgI;EAAhI,kBAAgI;EAAhI,yDAAgI;EAAhI,kBAAgI;EAAhI,mBAAgI;EAAhI,oBAAgI;EAAhI,uBAAgI;EAAhI,oBAAgI;EAAhI;AAAgI;AAAhI;EAAA,sBAAgI;EAAhI,0DAAgI;EAAhI,8BAAgI;EAAhI;AAAgI;AAIhI;EAAA,8BAAiG;EAAjG;AAAiG;AAAjG;EAAA,kBAAiG;EAAjG,8BAAiG;EAAjG;AAAiG;AAAjG;EAAA,8BAAiG;EAAjG;AAAiG;AAAjG;EAAA,+FAAiG;EAAjG,wDAAiG;EAAjG;AAAiG;AAAjG;EAAA,oBAAiG;EAAjG;AAAiG;AAAjG;EAAA,oBAAiG;EAAjG;AAAiG;AAIjG;EAAA,iBAA6H;EAA7H,WAA6H;EAA7H,mBAA6H;EAA7H,iBAA6H;EAA7H,sBAA6H;EAA7H,4DAA6H;EAA7H,kBAA6H;EAA7H,mBAA6H;EAA7H,mBAA6H;EAA7H,sBAA6H;EAA7H,oBAA6H;EAA7H;AAA6H;AAA7H;EAAA,sBAA6H;EAA7H,2DAA6H;EAA7H,8BAA6H;EAA7H;AAA6H;AAI7H;EAAA,eAA2B;EAA3B,oBAA2B;EAA3B,qBAA2B;EAA3B,oBAA2B;EAA3B;AAA2B;AAI3B;EAAA,aAAqD;EAArD,sBAAqD;EAArD,uBAAqD;EAArD,uBAAqD;EAArD;AAAqD;AAlLvD;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAuLlB;EACC,8DAA8D;CAC/D;AAzLD;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;CACC,uBAAuB;AACxB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,8CAA8C;AAC/C;;AAEA;CACC,2BAA2B;CAC3B,4BAA4B;AAC7B;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,YAAY;AACb;;AAEA;CACC;;;;;;EAMC;CACD,0BAA0B;AAC3B;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC;EACC,6BAA6B;CAC9B;CACA;EACC,4BAA4B;CAC7B;CACA;EACC,2BAA2B;CAC5B;AACD;;AAEA;CACC;EACC,mBAAmB;EACnB,UAAU;CACX;CACA;EACC,qBAAqB;EACrB,YAAY;CACb;CACA;EACC,mBAAmB;EACnB,UAAU;CACX;AACD;;AAEA;CACC;;EAEC,UAAU;CACX;CACA;;EAEC,UAAU;CACX;AACD;;AAEA;CACC,iCAAiC;AAClC;;AAMA;CACC,oBAAoB;CACpB,4CAAiD;AAClD;;AApHA;CAwHE;IAAA,aAAuC;IAAvC,mBAAuC;IAAvC;EAAuC;AAqEzC;;AA7LA;EAAA;AA6LA;;AA7LA;EAAA;AA6LA;;AA7LA;EAAA;AA6LA;;AA7LA;EAAA,oBA6LA;EA7LA;AA6LA;;AA7LA;EAAA,oBA6LA;EA7LA;AA6LA;;AA7LA;EAAA,sBA6LA;EA7LA;AA6LA;;AA7LA;EAAA,sBA6LA;EA7LA;AA6LA;;AA7LA;EAAA;AA6LA;;AA7LA;EAAA,kBA6LA;EA7LA;AA6LA;;AA7LA;EAAA,oBA6LA;EA7LA;AA6LA;;AA7LA;EAAA,oBA6LA;EA7LA;AA6LA;;AA7LA;EAAA,oBA6LA;EA7LA;AA6LA;;AA7LA;EAAA;AA6LA;;AA7LA;EAAA,0EA6LA;EA7LA,8FA6LA;EA7LA;AA6LA;;AA7LA;EAAA,oBA6LA;EA7LA;AA6LA;;AA7LA;EAAA;AA6LA;;AA7LA;EAAA;AA6LA;;AA7LA;EAAA;AA6LA;;AA7LA;EAAA,oBA6LA;EA7LA;AA6LA;;AA7LA;EAAA,eA6LA;EA7LA,eA6LA;EA7LA;AA6LA;;AA7LA;EAAA,oBA6LA;EA7LA;AA6LA;;AA7LA;;EAAA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA,qBA6LA;IA7LA;EA6LA;AAAA;;AA7LA;;EAAA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA,kBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,kBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,oBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,kBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,qBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,sBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,oBA6LA;IA7LA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA,kBA6LA;IA7LA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA,eA6LA;IA7LA;EA6LA;;EA7LA;IAAA,mBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,mBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,kBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,kBA6LA;IA7LA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;AAAA;;AA7LA;;EAAA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA,sBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,qBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,qBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,uBA6LA;IA7LA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA,6BA6LA;IA7LA;EA6LA;;EA7LA;IAAA,oBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,kBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,oBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,oBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,iBA6LA;IA7LA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;AAAA;;AA7LA;;EAAA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA,qBA6LA;IA7LA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA,kBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,kBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,kBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,kBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,oBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,kBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,sBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,sBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,mBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,oBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,iBA6LA;IA7LA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA,iBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,kBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,eA6LA;IA7LA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA,eA6LA;IA7LA;EA6LA;;EA7LA;IAAA,kBA6LA;IA7LA;EA6LA;;EA7LA;IAAA;EA6LA;AAAA;;AA7LA;;EAAA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA,kBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,kBA6LA;IA7LA;EA6LA;;EA7LA;IAAA,sBA6LA;IA7LA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA;EA6LA;;EA7LA;IAAA,mBA6LA;IA7LA;EA6LA;AAAA;;AA7LA;;EAAA;IAAA;EA6LA;;EA7LA;IAAA,6BA6LA;IA7LA;EA6LA;;EA7LA;IAAA,kBA6LA;IA7LA;EA6LA;AAAA;;AA7LA;EAAA,mBA6LA;EA7LA;AA6LA;;AA7LA;EAAA,oBA6LA;EA7LA;AA6LA;;AA7LA;;EAAA;IAAA,oBA6LA;IA7LA;EA6LA;AAAA;;AA7LA;;EAAA;IAAA,oBA6LA;IA7LA;EA6LA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nhtml {\n\tscroll-behavior: smooth;\n}\n\n::-webkit-scrollbar-track {\n\tbackground-color: rgba(0, 0, 0, 0);\n}\n\n::-webkit-scrollbar-thumb {\n\tbackground-color: #444444;\n\tborder-radius: 4px;\n}\n\n::-webkit-scrollbar {\n\tbackground-color: rgba(68, 68, 68, 0.9);\n}\n\n::-webkit-scrollbar-thumb:horizontal {\n\tbackground-color: #444444;\n}\n\n.react-pricing-table {\n\twidth: 100%;\n}\n\n.price {\n\ttransition: transform 0.5s ease-out !important;\n}\n\n.price:hover {\n\tmargin-top: 20px !important;\n\ttransform: translateY(-20px);\n}\n\n#basic-header {\n\tbackground-color: #ff6600;\n\tcolor: #ffffff;\n}\n\n.mask {\n\tcolor: #454e5c;\n\topacity: 0.8;\n}\n\n.header {\n\tbackground: linear-gradient(\n\t\t-45deg,\n\t\ttransparent,\n\t\ttransparent,\n\t\t#272727,\n\t\t#272727\n\t);\n\tbackground-size: 400% 400%;\n}\n\n.header-rtl-animation {\n\tanimation: header-animation 2s ease;\n}\n\n.header-ltr-animation {\n\tanimation: header-animation 2s ease reverse;\n}\n\n@keyframes header-animation {\n\t0% {\n\t\tbackground-position: 100% 50%;\n\t}\n\t50% {\n\t\tbackground-position: 50% 50%;\n\t}\n\t100% {\n\t\tbackground-position: 0% 50%;\n\t}\n}\n\n@keyframes pulsate {\n\t0% {\n\t\ttransform: scale(1);\n\t\topacity: 1;\n\t}\n\t50% {\n\t\ttransform: scale(1.4);\n\t\topacity: 0.7;\n\t}\n\t100% {\n\t\ttransform: scale(1);\n\t\topacity: 1;\n\t}\n}\n\n@keyframes fadeInOut {\n\t0%,\n\t100% {\n\t\topacity: 0;\n\t}\n\t10%,\n\t90% {\n\t\topacity: 1;\n\t}\n}\n\n* {\n\tfont-variant-numeric: lining-nums;\n}\n\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap\");\n\n@font-face {\n\tfont-family: \"snasm\";\n\tsrc: url(\"../assets/fonts/Snasm-W05-Regular.ttf\");\n}\n\n@layer components {\n\t.flex-center {\n\t\t@apply flex items-center justify-center;\n\t}\n\n\t.grid-center {\n\t\t@apply grid place-items-center;\n\t}\n\n\t.flex-between {\n\t\t@apply flex items-center justify-between;\n\t}\n\n\t.center-absolute {\n\t\t@apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2;\n\t}\n\n\t.primary-btn {\n\t\t@apply bg-primary-orange border border-transparent text-white font-manrope text-sm lg:text-base font-semibold py-3 shadow-primary-btn hover:bg-transparent hover:border-white hover:shadow-secondary-btn transition-all;\n\t}\n\n\t.disable-focus {\n\t\t@apply focus-within:outline-none focus:outline-none focus-visible:outline-none focus:border-none;\n\t}\n\n\t.text-secondary {\n\t\t@apply font-manrope text-xs sm:text-sm lg:text-base font-normal text-white-80;\n\t}\n\n\t.os-icon {\n\t\t@apply w-[80px] h-[80px] flex-center bg-[#A3A3A3] hover:bg-primary-orange rounded-full transition-colors;\n\t}\n\n\t.get-app-button {\n\t\t@apply object-cover max-w-none;\n\t}\n\n\t.focus-button {\n\t\t@apply hover:text-primary-orange hover:border-primary-orange disable-focus focus-within:text-primary-orange focus:text-primary-orange focus-within:border-primary-orange focus:border-primary-orange focus:border-solid;\n\t}\n\n\t.auth-button {\n\t\t@apply primary-btn font-normal shadow-none hover:shadow-none rounded py-[0.625rem] min-w-[108px];\n\t}\n\n\t.input {\n\t\t@apply px-4 py-3 bg-[#1D1D1D] border border-transparent focus:border-primary-orange rounded w-full focus:outline-none text-white;\n\t}\n\n\t.text-focus {\n\t\t@apply disable-focus hover:text-primary-orange focus-within:text-primary-orange transition-colors;\n\t}\n\n\t.select {\n\t\t@apply w-full max-h-[350px] border-slate-500 px-4 py-2 border focus:border-blue-500 rounded-2xl focus:outline-none text-black;\n\t}\n\n\t.select-option {\n\t\t@apply px-2 py-1 max-w-full;\n\t}\n\n\t.label {\n\t\t@apply flex flex-col gap-1 justify-center items-start;\n\t}\n}\n\n@layer utilities {\n\t.clip-bottom {\n\t\tclip-path: polygon(0 0, 100% 0, 100% 100%, 0 calc(100% - 6vw));\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
